<template>
  <Component
    :is="isHero ? 'header' : 'ContentSection'"
    :class="[
      { 'pb-12 sm:pb-18': isHero },
    ]"
  >
    <div
      v-if="data"
      class="w-full overflow-hidden md:relative md:flex md:items-stretch"
      :class="isFlat ? 'md:min-h-80' : 'md:min-h-180'"
    >
      <!-- BackgroundMedia set to absolute -->
      <BackgroundMedia
        :data="backgroundMedia"
        :autoplay="true"
        class="md:!absolute md:inset-0"
      />

      <!-- Container set to relative so it contributes to height -->
      <Container
        class="w-full pt-9 md:relative md:flex md:flex-col"
        :class="[
          isFlat ? 'md:justify-center md:py-20' : 'md:justify-end md:py-40',
          {
            'items-end': data.text_position?.value === 'right',
          }]"
      >
        <AnimatedContainer
          v-if="data.heading || (data.link && data.link_text)"
          class="pointer-events-auto bg-white/50 md:max-w-lg md:p-9"
        >
          <Component
            :is="isHero ? 'h1' : 'h2'"
            v-if="data.heading"
            class="slide-up font-semibold"
            :class="isHero ? 'typo-h3' : 'typo-h4'"
          >
            {{ data.heading }}
          </Component>
          <p v-if="data.lead && !isFlat" class="slide-up mt-3 typo-lead">
            {{ data.lead }}
          </p>

          <div class="slide-up">
            <AppButton
              v-if="data.link && data.link_text"
              class="max-sm:w-full"
              :to="data.link"
              :class="{
                'mt-6': data.lead || data.heading,
              }"
            >
              {{ data.link_text }}
            </AppButton>
          </div>
        </AnimatedContainer>
      </Container>
    </div>
  </Component>
</template>

<script setup lang="ts">
import type { MainComponentsComponentHeroModuleFragment } from '#gql'

const props = withDefaults(defineProps<{
  data: Enforce<MainComponentsComponentHeroModuleFragment>
}>(), {
})

const isHero = inject<boolean>('isHero', false)

const backgroundMedia = {
  media_type: props.data?.media_type ?? 'image',
  image: props.data?.image,
  video: props.data?.video,
  cover_image: props.data?.cover_image,
}

const isFlat = computed(() => props.data.height?.value === 'flat')
</script>
